import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { addTrainer, uploadTrainerImage } from '../../services/trainerServices';
import BasicInfoEdit from './BasicInfo/BasicInfoEdit';
import { beforeImageUpload } from '../../utilities/imageUpload';

function TrainerAdd(props) {
  const { isOpen, toggle } = props;

  const history = useHistory();
  const [status, setStatus] = useState({
    type: 'IDLE',
    message: 'On Idle Mode!',
  });

  const [initialValues, setInitialValues] = useState({
    firstName: '',
    lastName: '',
    description: '',
    longDescription: '',
    profileImage: '',
    countryId: '',
    meetFacilitatorImg: '',
  });

  async function onSubmit(values) {
    setStatus({ type: 'LOADING', message: 'Loading data!' });
    let payload = {
      ...values,
      interests: [],
      creations: [],
      socialMedia: [],
      milestones: [],
    };
    await addTrainer(payload)
      .then((response) => {
        setStatus({ type: 'SUCCESS', message: 'Successfully added trainer!' });
        history.push('/trainer/' + response.data.trainer.trainerId);
      })
      .catch((err) => {
        console.log('Error getting data from the admin backend:', err);
        alert('Getting data from the backend failed!');
        setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  }

  const onImageUpload = async (e) => {
    const formData = new FormData();
    formData.append('name', e.file.name);
    formData.append('image', e.file);
    await uploadTrainerImage(formData, 'avatar')
      .then((res) => {
        setInitialValues({
          ...initialValues,
          ...{ profileImage: res.data.imageUrl },
        });
      })
      .catch((err) => {
        alert(err);
        setStatus({ type: 'ERROR', message: 'Something went wrong!' });
      });
  };

  return (
    <BasicInfoEdit
      type="ADD"
      isOpen={isOpen}
      toggle={toggle}
      initialValues={initialValues}
      onSubmit={onSubmit}
      status={status}
      beforeImageUpload={beforeImageUpload}
      onImageUpload={onImageUpload}
    />
  );
}

export default TrainerAdd;
